import { render, staticRenderFns } from "./sharedLegend.vue?vue&type=template&id=552ecce5&scoped=true"
import script from "./sharedLegend.vue?vue&type=script&lang=js"
export * from "./sharedLegend.vue?vue&type=script&lang=js"
import style0 from "./sharedLegend.vue?vue&type=style&index=0&id=552ecce5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552ecce5",
  null
  
)

export default component.exports